export function formatLeagueName(league) {
  if (!league) {
    return '';
  }

  return String(league)
    .replace(/^\d+-/, '')
    .replace(/-/g, ' ')
    .trim();
}
